export default "__VITE_ASSET__CMp1zK7F__ 1000w";